module.exports = __webpack_public_path__ + "ellipse_shape_overlay-99b25be50b98eaf0eeaf32cc0461e959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/ellipse_shape_overlay.png
// module id = 1552
// module chunks = 1